"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("next/router");
const react_1 = require("react");
function usePageTransitionJustStarted() {
    const { events } = (0, router_1.useRouter)();
    const [justStarted, set] = (0, react_1.useState)(false);
    function onStartTransition() {
        set(true);
        requestAnimationFrame(() => {
            set(false);
        });
    }
    (0, react_1.useEffect)(() => {
        events.on('routeChangeStart', onStartTransition);
        return () => {
            events.off('routeChangeStart', onStartTransition);
        };
    }, [events]);
    return justStarted;
}
exports.default = usePageTransitionJustStarted;
//# sourceMappingURL=usePageTransitionJustStarted.js.map